import React from 'react';
import Fade from 'react-reveal/Fade';

import CONST from '../const';
import themes from './mainScreen/themes';
// import Menu from './mainScreen/Menu';
import HeroText from './mainScreen/HeroText';
import Background from './mainScreen/Background';
import LearnMoreBtn from './mainScreen/LearnMoreBtn';
import LoginSidebar from './mainScreen/LoginSidebar';
import RegistrationSidebar from './mainScreen/RegistrationSidebar';
import ForgotPasswordSidebar from './mainScreen/ForgotPasswordSidebar';
import { Loader } from './features/button';
import { isClient } from '../util';
import '../styles/mainscreen.scss';

const { LOGIN, REGISTRATION, FORGOT } = CONST.SIDEBAR_MODE;

class MainScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTheme: 0,
      showLoginSidebar: false,
      showRegistrationSidebar: false,
      showForgotSidebar: false,
      role: '',
    };

    this.counter = null;

    this.mainScreen = React.createRef();
    this.sidebarLogin = React.createRef();
    this.sidebarRegistration = React.createRef();
    this.sidebarForgot = React.createRef();

    this.count = this.count.bind(this);
    this.changeTheme = this.changeTheme.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.setUserRole = this.setUserRole.bind(this);
  }

  componentDidMount() {
    this.counter = setInterval(this.count, 10000);
  }

  componentDidUpdate() {
    const { showLoader } = this.state;
    const ele = document.body;
    if (showLoader && ele) {
      ele.style.overflow = 'hidden';
    } else if (ele) {
      ele.style.overflow = 'auto';
    }
  }

  componentWillUnmount() {
    clearInterval(this.counter);
  }

  setUserRole(role) {
    this.setState({ role });
  }


  closeAllSidebars = () => {
    this.setState({
      showForgotSidebar: false,
      showLoginSidebar: false,
      showRegistrationSidebar: false,
      showLoader: true,
    });
    this.counter = setInterval(this.count, 10000);
    document.body.style.overflow = 'hidden';
  }

  count() {
    this.setState(state => ({
      currentTheme: (state.currentTheme + 1) % 3,
    }));
  }

  changeTheme(currentTheme) {
    this.setState({
      currentTheme,
    });
  }

  toggleSidebar(mode, value) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    this.setState(
      { [`show${mode}Sidebar`]: value },
      () => {
        const { showForgotSidebar, showRegistrationSidebar, showLoginSidebar } = this.state;
        if (showForgotSidebar || showRegistrationSidebar || showLoginSidebar) {
          clearInterval(this.counter);
        } else {
          this.counter = setInterval(this.count, 10000);
        }
      },
    );
  }

  render() {
    const {
      currentTheme,
      showRegistrationSidebar,
      showLoginSidebar,
      showForgotSidebar,
      role,
      showLoader,
    } = this.state;
    const enableAnimations = !showRegistrationSidebar && !showLoginSidebar && !showForgotSidebar;
    const hideButton = showRegistrationSidebar || showLoginSidebar || showForgotSidebar;
    const toggleLoginSidebar = value => this.toggleSidebar(LOGIN, value);
    const toggleRegistrationSidebar = value => this.toggleSidebar(REGISTRATION, value);
    const toggleForgotSidebar = value => this.toggleSidebar(FORGOT, value);
    const display = !enableAnimations ? 'none' : 'block';
    if (isClient()) {
      const ele = document.getElementsByClassName('header');
      if (ele.length) {
        ele[0].style.display = display;
      }
    }
    return (
      <>
        {
          showLoader ? (
            <div className="loader-container">
              <Loader className="light-loader" />
            </div>
          ) : ''
        }
        <LoginSidebar
          active={showLoginSidebar}
          forwardRef={this.sidebarLogin}
          toggleLoginSidebar={toggleLoginSidebar}
          toggleRegistrationSidebar={toggleRegistrationSidebar}
          toggleForgotSidebar={toggleForgotSidebar}
          role={role}
          closeAllSidebars={this.closeAllSidebars}
        />
        <RegistrationSidebar
          active={showRegistrationSidebar}
          forwardRef={this.sidebarRegistration}
          toggleLoginSidebar={toggleLoginSidebar}
          toggleRegistrationSidebar={toggleRegistrationSidebar}
          role={role}
          closeAllSidebars={this.closeAllSidebars}
        />
        <ForgotPasswordSidebar
          active={showForgotSidebar}
          forwardRef={this.sidebarForgot}
          toggleLoginSidebar={toggleLoginSidebar}
          toggleRegistrationSidebar={toggleRegistrationSidebar}
          toggleForgotSidebar={toggleForgotSidebar}
          role={role}
        />

        <section className="main-screen" ref={this.mainScreen}>
          {/* <Menu active={enableAnimations} /> */}
          <Background
            currentTheme={currentTheme}
            enableAnimations={enableAnimations}
          />
          <HeroText
            currentTheme={currentTheme}
            changeTheme={this.changeTheme}
            toggleLoginSidebar={toggleLoginSidebar}
            showHeroText={enableAnimations}
            toggleRegistrationSidebar={toggleRegistrationSidebar}
            setUserRole={this.setUserRole}
          />
          {
            !hideButton
            && (
              <Fade>
                <LearnMoreBtn
                  mainScreen={this.mainScreen}
                  theme={themes[currentTheme]}
                />
              </Fade>
            )
          }
        </section>
      </>
    );
  }
}

export default MainScreen;
